<template>
    <v-dialog max-width="1200px" v-model="dialog" persistent>
        <v-card>
            <v-toolbar color="primary" dark>
                <v-toolbar-title style="padding-left: 0px">
                    Lịch sử sửa chữa
                </v-toolbar-title>
            </v-toolbar>
            <v-btn
                @click="close"
                icon
                style="position: absolute; right: 10px; top: 10px; color: #fff"
            >
                <v-icon>cancel</v-icon>
            </v-btn>
            <v-card-text>
                <v-layout wrap style="padding: 10px;">
                    <v-flex xs12 sm12 md6>
                        <p class="font-weight-bold">
                            Mã quản lý:
                            {{ fixedAssetsCode }}
                        </p>
                        <p class="font-weight-bold">
                            Tên tài sản:
                            {{ fixedAssetsName }}
                        </p>
                    </v-flex>
                    <v-flex xs12 sm12 md6>
                        <p class="font-weight-bold">
                            Bộ phận sử dụng hiện tại:
                            {{ departmentName }}
                        </p>
                        <p class="font-weight-bold">
                            Địa điểm sử dụng hiện tại:
                            {{ locationName }}
                        </p>
                    </v-flex>
                </v-layout>
            </v-card-text>
            <v-card-text>
                <table class="lstTable" v-if="lstHistory.length > 0">
                    <tr>
                        <th width="15%">STT</th>
                        <th width="20%">Ngày sửa chữa</th>
                        <th width="25%">Nộ dung sửa chữa</th>
                        <th width="20%">Đơn vị sửa chữa</th>
                        <th width="20%" v-if="showPrice">Chi phí sửa chữa</th>
                    </tr>
                    <template v-for="(item, k) in lstHistory">
                        <tr :key="k">
                            <td style="text-align: center;">{{ k+1 }}</td>
                            <td style="text-align: center;">{{item.repairDate|formatDate}}</td>
                            <td>{{item.content}}</td>
                            <td>{{item.repairUnitName}}</td>
                            <td v-if="showPrice" style="text-align: right;">{{item.repairCost|currency}}</td>
                        </tr>
                    </template>
                    <tr v-if="showPrice">
                        <td colspan="3"></td>
                        <td style="text-align: center;"><strong>Tổng</strong></td>
                        <td style="text-align: right;"><strong>{{totalRepairCost()|currency}}</strong></td>
                    </tr>
                </table>
                <div v-else style="border:1px solid grey;border-radius: 10px;padding: 10px">Không có lịch sử
                </div>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="success" @click="viewDetail">
                    <v-icon left>visibility</v-icon>
                    Xem báo cáo chi tiết
                </v-btn>
                <v-btn color="error" @click="close">
                    <v-icon dark left>cancel</v-icon>
                    {{ $t("lang.common.close") }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

import CSearchForm from "../../../components/form/ManageForm";
import axios from "axios";
import { roleConstants } from "@/constants";

export default {
    name: "repair-history",
    components: { CSearchForm },
    props: {
        dialog: {
            type: Boolean,
            default: false,
        },
        propsItem: {
            type: Object,
            default: ()=> {}
        },
        backTo: {
            type: String,
            default: '',
        },
    },
    data: () => {
        return {
            lstHistory: [],
            fixedAssetsId: '',
            fixedAssetsName: '',
            fixedAssetsCode: '',
            locationName: '',
            departmentName: '',
            lstLocation: [],
            lstDepartment: [],
        };
    },
    watch: {
        propsItem: {
            handler(value) {
                console.log(value);
                if (value !== null) {
                    this.fixedAssetsId = value.fixedAssetsId;
                    this.fixedAssetsName = value.name;
                    this.fixedAssetsCode = value.code;
                    this.getHistory(value.fixedAssetsId);

                    if (value.locationId != null) {
                        const location = this.lstLocation.find(o => o.categoryId === value.locationId );
                        if (location !== undefined && typeof location == 'object') {
                            this.locationName = location.categoryName;
                        }
                    }

                    if (value.departmentId != null) {
                        const department = this.lstDepartment.find(o => o.deptId === value.departmentId );
                        if (department !== undefined && typeof department == 'object') {
                            this.departmentName = department.deptName;
                        }
                    }
                } else {
                    this.fixedAssetsName = '';
                    this.fixedAssetsCode = '';
                    this.locationName = '';
                    this.departmentName = '';
                    this.fixedAssetsId = '';
                    this.lstHistory = [];
                }
            },
            deep: true,
        },
    },
    created() {
        this.getLocation();
        this.getDepartment();
    },
    computed: {
        showPrice() {
            if (this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.PURCHASE
                || this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.DIRECTOR
                || this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.ACCOUNTANT
                || this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.ADMIN) {
                return true;
            } else {
                return false;
            }
        },
    },
    methods: {
        close() {
            this.$emit("close");
        },
        viewDetail() {
            this.$router.push({path: '/fixedAssetsRepair/create', query: {fixedAssetsId: this.fixedAssetsId, backTo: this.backTo}});
        },
        getLocation() {
            axios.post(
                    process.env.VUE_APP_API_URL + "/category/listByTypeOrderByCodeAsc?type=OFFICE_LOCATION"
                )
                .then(
                    (data) => {
                        if (data.length > 0) {
                            this.lstLocation = data;
                        }
                    }
                );
        },
        getDepartment() {
            axios.post(process.env.VUE_APP_API_URL + "/department/search?pageSize=-1&page=-1", {})
            .then(
                (data) => {
                    if (data.items) {
                        this.lstDepartment = data.items;
                    }
                }
            );
        },
        getHistory(fixedAssetsId) {
            axios.post(process.env.VUE_APP_API_URL + "/fixedAssetsRepair/search?pageSize=-1&page=-1&sortField=repairDate&orderBy=desc", {fixedAssetsId: fixedAssetsId})
            .then(
                (data) => {
                    if (data.items) {
                        this.lstHistory = data.items;
                    }
                }
            );
        },
        totalRepairCost() {
            let total = 0;
            for (let i = 0; i < this.lstHistory.length; i++) {
                total += this.lstHistory[i].repairCost;
            }
            return total;
        },
    },
    destroyed() {},
};
</script>
